"use strict";

$.widget("fotobook.lineHeightBaseWidget", $.fotobook.containereditorbasecontrol, {
    "options" : {
        "def_size" : 1.25,
        "min_size" : 0.5,
        "max_size" : 2,
    },
    input: null,
    _create: function(){
        var widget = this;
        this._createLayout();
        this.input.floatNumberInput({
            "max" : this.options.max_size,
            "min" : this.options.min_size,
            "step" : 0.05,
            "input" : function(event, lineHeight){
                widget._setPreviewStyle(lineHeight);
            },
            "change" : function(event, lineHeight){
                widget._changeLineHeight(lineHeight);
            },
            "cancel" : function(event, lineHeight){
                widget._removePreviewStyle(lineHeight);
            },
        });
        this._super();
    },

    _createLayout: function(){
        this.input = $("<input>", {
            "class" : "line-spacing-widget",
            "type" : "text",
            "maxlength" : 2,
        });
        this.element.append(this.input);
    },

    _containerChanged: function(){
        this.input.floatNumberInput("value", this._getValueFromProject());
        this._super();
    },

    _getValueFromProject: function(){
        return 0;
    },

    _setPreviewStyle: $.noop,
    _removePreviewStyle: $.noop,
    _changeLineHeight: $.noop,

    _destroy: function(){
        this._super();
        this.input.remove();
    },
});
